import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled('div')`
  display: flex;
  span {
    display: block;
    margin-top: 10px;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const AlertBlock = (props) => {
  const { type = 'light', message } = props;

  return (
    <Wrapper className={`alert alert-${type} insufficient-data-warning`} role="alert">
      <i className="fe-alert-circle mr-2" style={{ fontSize: '20px' }} />
      <div>{message}</div>
    </Wrapper>
  );
};

export default AlertBlock;
